module.exports = "/assets/c6c6db2b61383de870cc3ab6e8ba364e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/cff.svg
// module id = 3596
// module chunks = 0